export default "__VITE_ASSET__CJCYe1Z8__";